import Store from 'store/store';
import { homeEntApi } from 'utils/bolt/api';
import { handleProducts } from 'utils/bolt/homeEnt';
import { accessNested } from 'utils/utils';
// import { getPreviewPanelHomeEntData } from 'utils/bolt/previewPanel';
import pendingPromise from 'utils/pendingPromise';

Store.on('GET_HOMEENT_DATA', async (pageId = 'boltHomeEnt', options) => {
	let homeEntState = Store.get().homeEnt;
	let promise = pendingPromise();
	homeEntState.set({ loading: promise, ['loading-' + pageId]: promise, error: false });

	const dataToSend = {};

	const useDummyData = accessNested(Store.get(), 'appData.options.useDummyDataHomeEnt', false);
	if (useDummyData) {
		dataToSend.useDummyData = true;
	}

	const thundrHomeEntData = options?.pageData || Store.get().appData?.pages?.[pageId]?.data;

	let {
		titleIds,
		jwFilmIdType,
		regions,
		hideMerchants = '',
		hideFormats = '',
		hideAvailabilities = '',
		hideProducts = '',
		addProducts = {},
		addProductsMultiRegion = {}
	} = thundrHomeEntData;

	addProducts = JSON.parse(JSON.stringify(addProducts));

	addProductsMultiRegion = JSON.parse(JSON.stringify(addProductsMultiRegion));

	if (Object.keys(addProducts).length) {
		addProducts = handleProducts(addProducts);
	}

	if (Object.keys(addProductsMultiRegion).length) {
		Object.keys(addProductsMultiRegion).forEach((region) => {
			addProductsMultiRegion[region] = handleProducts(addProductsMultiRegion[region]);
		});
	}

	if (!titleIds && !useDummyData) {
		const data = Object.keys(addProducts).length ? addProducts : addProductsMultiRegion;
		Store.get().homeEnt.set({
			data,
			['data-' + pageId]: data,
			loading: false,
			['loading-' + pageId]: false
		});
		promise.resolve(data);
		// getPreviewPanelHomeEntData(pageId, options);
		return;
	}

	let FAFId;
	let hasFAFData;
	let hasJustWatchData;

	if (titleIds) {
		titleIds = titleIds.replace(/\s/g, '').split(',').map(id => id.split('-'));

		hasFAFData = titleIds.some(el => el[0] === 'FAF');
		hasJustWatchData = titleIds.some(el => el[0] === 'JW');

		titleIds.forEach(id => {
			if (id[0].toUpperCase() === 'JW') {
				dataToSend.justWatchId = id[1];
			}
			if (id[0].toUpperCase() === 'FAF') {
				FAFId = id[1];
				dataToSend.fafId = id[1];
			}
		});

		if (hasJustWatchData && jwFilmIdType) {
			dataToSend.jwFilmIdType = jwFilmIdType;
		}
	}

	const thundrData = {
		homeEntData: {
			hideMerchants,
			hideFormats,
			hideAvailabilities,
			hideProducts,
			addProducts
		}
	};

	dataToSend.thundrData = thundrData;

	if (!regions && useDummyData) {
		regions = 'gb';
	}
	const regionsNeeded = regions.toLowerCase().replace(/\s/g, '').split(',');
	const multiRegion = regionsNeeded.length > 1 || Object.keys(addProductsMultiRegion).length > 0;
	let fullData = {};

	const promises = regionsNeeded.map(async (region) => {
		dataToSend.jwRegion = region;
		if (FAFId) {
			if (region === 'gb') {
				dataToSend.fafId = FAFId;
			} else {
				delete dataToSend.fafId;
			}
		}

		if (addProductsMultiRegion[region]) {
			thundrData.homeEntData.addProducts = addProductsMultiRegion[region];
		} else if (multiRegion && !addProductsMultiRegion[region]) {
			thundrData.homeEntData.addProducts = {};
		}

		let apiResponse;

		try {
			apiResponse = await homeEntApi(dataToSend);
			if (multiRegion) {
				fullData[region] = apiResponse;
			} else {
				fullData = apiResponse;
			}

		} catch (err) {
			return { err };
		}

		return apiResponse;
	});

	const result = await Promise.all(promises);
	const hasOneCorrect = result.some(x => !x.err);
	if (!hasOneCorrect) {
		let error = result?.[0]?.err?.message || result?.[0].err || 'No regions set';
		Store.get().homeEnt.set({ error, loading: false, ['loading-' + pageId]: false });
		promise.reject(error);
		return;
	}

	// Add in manual regional data that we did not pull from the api
	const remainingManualRegions = Object.keys(addProductsMultiRegion).filter(region => !regionsNeeded.includes(region));
	remainingManualRegions.forEach((region) => {
		fullData[region] = addProductsMultiRegion[region];
	});

	Store.get().homeEnt.set({
		data: fullData,
		['data-' + pageId]: fullData,
		loading: false,
		['loading-' + pageId]: false,
		hasFAFData,
		hasJustWatchData
	});
	promise.resolve(fullData);

	// getPreviewPanelHomeEntData(pageId, options);
});

Store.on('OPEN_MERCHANT_SECTION', () => {
	Store.get().header.set({ homeEntMerchantOpen: true, interstitialOpen: true });
});

Store.on('CLOSE_MERCHANT_SECTION', () => {
	Store.get().header.set({ homeEntMerchantOpen: false, interstitialOpen: false });
});

Store.on('RESTRICT_AVAILABILITY', (avail) => {
	Store.get().homeEnt.set({
		restrictedAvailability: avail
	});
});
